import React from 'react';
import { Card, Select, Badge } from 'antd';
import { useTranslation } from 'react-i18next';
import { history } from '../../../redux/store';
import './Trick.less';

const { Option } = Select;

interface Props {
  trick: {
    id: number;
    points: number;
    thumb: string;
    name: string;
    price: number;
  };
  my?: boolean;
}

const Trick = (props: Props) => {
  const { t } = useTranslation('genericScreen');
  const trick = props.trick;
  const my = props.my;

  return (
    <Badge.Ribbon text={trick.points + ' ' + t('points')} color="purple">
      <Card
        hoverable
        onClick={() => {
          !my ? history.push('/tricks/' + trick.id) : history.push('/tricks/my/' + trick.id);
        }}
        className="dog-card"
        cover={
          <div
            className="trick-pic"
            style={{
              minWidth: 140,
              minHeight: 170,
              backgroundImage: `url(${trick.thumb})`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat'
            }}
          />
        }
      >
        <div className="title">{trick.name}</div>
        {!my && (
          <div className="price">
            {t('gbp')} {trick.price}
          </div>
        )}
      </Card>
    </Badge.Ribbon>
  );
};

export default Trick;
